import { render, staticRenderFns } from "./EditClinics.vue?vue&type=template&id=5ef12e13&scoped=true"
import script from "./EditClinics.vue?vue&type=script&lang=js"
export * from "./EditClinics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef12e13",
  null
  
)

export default component.exports